document.addEventListener('click', function (event) {
  const button = event.target.closest('.quantity-selector__button');
  if (!button) return;

  const wrapper = button.closest('.quantity-selector');
  if (!wrapper) return;

  const input = wrapper.querySelector('.quantity-selector__input');
  const liveRegion = document.getElementById('quantity-live');
  if (!input || !liveRegion) return;

  const previousValue = Number(input.dataset.prevValue || input.value);

  // Wait for theme JS to update the value
  setTimeout(() => {
    const currentValue = Number(input.value);

    if (currentValue > previousValue) {
      liveRegion.textContent = `Quantity increased to ${currentValue}`;
    } else if (currentValue < previousValue) {
      liveRegion.textContent = `Quantity decreased to ${currentValue}`;
    }

    input.dataset.prevValue = currentValue;
  }, 50);
});
